import React from 'react';
import { VENDEDOR_SPECIALTY_OPTIONS } from '../../../utils/adminVendedoresApi';

export const AdminVendedorFormModal = ({
  isOpen,
  mode,
  formData,
  setFormData,
  onClose,
  onSubmit,
}) => {
  if (!isOpen) {
    return null;
  }

  const modalPrefix = mode === 'edit' ? 'edit' : 'add';

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4" data-testid={`admin-vendedores-${modalPrefix}-modal-overlay`}>
      <div className="bg-white rounded-2xl w-full max-w-md max-h-[90vh] overflow-y-auto" data-testid={`admin-vendedores-${modalPrefix}-modal`}>
        <div className="p-6">
          <h2 className="text-xl font-bold text-gray-900 mb-4" data-testid={`admin-vendedores-${modalPrefix}-modal-title`}>
            {mode === 'edit' ? 'Editar Vendedor' : 'Novo Vendedor'}
          </h2>

          <form onSubmit={onSubmit} className="space-y-4" data-testid={`admin-vendedores-${modalPrefix}-form`}>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Nome *</label>
              <input
                type="text"
                value={formData.nome}
                onChange={(event) => setFormData({ ...formData, nome: event.target.value })}
                required
                className="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500"
                data-testid={`admin-vendedores-${modalPrefix}-name-input`}
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Telefone</label>
              <input
                type="tel"
                value={formData.telefone}
                onChange={(event) => setFormData({ ...formData, telefone: event.target.value })}
                className="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500"
                data-testid={`admin-vendedores-${modalPrefix}-telefone-input`}
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">WhatsApp</label>
              <input
                type="tel"
                value={formData.whatsapp}
                onChange={(event) => setFormData({ ...formData, whatsapp: event.target.value })}
                placeholder="5511999999999"
                className="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500"
                data-testid={`admin-vendedores-${modalPrefix}-whatsapp-input`}
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Email</label>
              <input
                type="email"
                value={formData.email}
                onChange={(event) => setFormData({ ...formData, email: event.target.value })}
                className="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500"
                data-testid={`admin-vendedores-${modalPrefix}-email-input`}
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">URL da Foto</label>
              <input
                type="url"
                value={formData.foto_url}
                onChange={(event) => setFormData({ ...formData, foto_url: event.target.value })}
                className="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500"
                data-testid={`admin-vendedores-${modalPrefix}-photo-url-input`}
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Especialidade</label>
              <select
                value={formData.especialidade}
                onChange={(event) => setFormData({ ...formData, especialidade: event.target.value })}
                className="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500"
                data-testid={`admin-vendedores-${modalPrefix}-specialty-select`}
              >
                {VENDEDOR_SPECIALTY_OPTIONS.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </select>
            </div>

            <div className="flex gap-3 pt-4">
              <button
                type="button"
                onClick={onClose}
                className="flex-1 px-4 py-2 border rounded-lg hover:bg-gray-50"
                data-testid={`admin-vendedores-${modalPrefix}-cancel-button`}
              >
                Cancelar
              </button>
              <button
                type="submit"
                className="flex-1 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
                data-testid={`admin-vendedores-${modalPrefix}-submit-button`}
              >
                {mode === 'edit' ? 'Salvar' : 'Adicionar'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};
